<a
  [href]="link"
  [class]="class"
  [class.ios-link-inherit]="isIosDevice"
  [title]="title || text"
  [attr.data-automation-id]="dataAutomationId || 'profile-preview-link'"
  [innerHTML]="innerHTML || text"
  (click)="openProfilePreview($event)"
>
  {{ text }}
</a>
